import { render, staticRenderFns } from "./select.vue?vue&type=template&id=bc33fbe2&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc33fbe2')) {
      api.createRecord('bc33fbe2', component.options)
    } else {
      api.reload('bc33fbe2', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=bc33fbe2&", function () {
      api.rerender('bc33fbe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/select.vue"
export default component.exports